class DetailsModal extends HTMLElement {
  constructor() {
    super();
    const self = this;
    this.detailsContainer = this.querySelector('.details-element');
    this.summaryToggle = this.querySelector('.summary-element');
    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && (e.target.classList.contains('close-dialog') || e.target.classList.contains('summary-element'))) {
        e.preventDefault();
      }
    });
    this.addEventListener('keyup', (e) => {
      if (e.key === 'Enter' && e.target.classList.contains('close-dialog')) {
        self.close();
      }
    });
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.summaryToggle.addEventListener(
      'keyup',
      function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          self.open(e);
        }
      }
    );
    this.querySelector('button.close-dialog').addEventListener(
      'click',
      this.close.bind(this)
    );
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {

    console.log('toggle summary details modal');
    event.preventDefault();
    event.target.closest('.details-element').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    console.log('Opening details modal');
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('.details-element').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    console.log('Closing details modal');
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
